import { ContentPage } from '@/features/content/content-page'
import { LinkedInRequiredGate } from '@/components/linkedin-required-gate'

export default function ContentRoute() {
  return (
    <LinkedInRequiredGate
      featureName="Content"
      description="AI-generated posts publish to your LinkedIn feed, and engagement on those posts feeds new leads back into your pipeline. Connect an account to start scheduling content."
    >
      <ContentPage />
    </LinkedInRequiredGate>
  )
}
